import React, { FC, useCallback, useState } from "react";
import { Block } from "kanopi-components/Block";
import { Button, SIZE, TButtonProps } from "kanopi-components/Button";
import { mergeOverrides } from "baseui";
import { Modal } from "kanopi-components/Modal";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { StripePaymentMethodForm } from "kw/components/PaymentMethod/StripePaymentMethodForm";
import { toaster } from "kanopi-components/ToastContainer";

type TEditPaymentMethodModal = {
  openModal: (arg: boolean) => void;
  title: string;
  handleSubmit: (arg: boolean) => void;
};

export const EditPaymentMethodModal: FC<TEditPaymentMethodModal> = ({
  openModal,
  title,
  handleSubmit,
}) => {
  const [, theme] = useStyletron();

  const submit = () => {
    openModal(false);
    toaster({
      kind: "POSITIVE",
      content: "Payment method updated successfully",
      key: "update-payment-method-success-toast",
    });
    handleSubmit();
  };
  const onClose = useCallback(() => {
    openModal(false);
  }, []);

  return (
    <Modal
      onClose={onClose}
      closeable
      isOpen={true}
      animate
      autoFocus
      overrides={{
        Dialog: {
          style: {
            minWidth: "30vw",
          },
        },
      }}
    >
      <Modal.Header $style={{ textAlign: "center" }}>{title}</Modal.Header>
      <Modal.Body $style={{ marginTop: theme.sizing.scale800 }}>
        <Block width="100%">
          <StripePaymentMethodForm onSubmit={submit} />
        </Block>
      </Modal.Body>
    </Modal>
  );
};

type TEditPaymentMethodButton = {
  title: string;
  handleSubmit: () => void;
} & TButtonProps;

export const EditPaymentMethodButton: FC<TEditPaymentMethodButton> = ({
  title,
  handleSubmit,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [, theme] = useStyletron();
  const openModal = (open: boolean) => {
    setIsOpen(open);
  };

  const onClick = useCallback(() => {
    openModal(true);
  }, []);
  const { color, overrides, size, ...restProps } = props;

  return (
    <>
      <Button
        size={size || SIZE.compact}
        outlined={true}
        onClick={onClick}
        overrides={mergeOverrides(
          {
            BaseButton: {
              style: {
                color: color,
                outlineColor: color || theme.colors.buttonPrimaryOutlinedBorder,
              },
            },
          },
          overrides
        )}
        {...restProps}
      >
        {title}
      </Button>

      {isOpen && (
        <EditPaymentMethodModal
          openModal={openModal}
          title={title}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
